import axios from 'axios';
import { RequestErrorHandler } from '@/connectors/request-error-handler.model';
import { ExtendedAxiosRequestConfig } from '@/connectors/axios-request-config.model';
import { BaseConnectorResponse } from '@/connectors/base-connector.model';
import { HttpPatch } from '@/connectors/http-patch.model';

export class BaseConnector {
  url: string;

  constructor(controller: string, rootUrl: string | null = null) {
    if (rootUrl !== null) {
      this.url = `${rootUrl}/${controller}`;
    } else {
      this.url = `${controller}`;
    }
  }

  async post<Tout>(
    method: string = '',
    body?: any,
    defaultErrorHandling: RequestErrorHandler = RequestErrorHandler.Snackbar
  ): Promise<BaseConnectorResponse<Tout>> {
    const response = await axios.post<Tout>(`${this.url}${method}`, body, {
      defaultErrorHandling
    } as ExtendedAxiosRequestConfig);

    return {
      result: response.data,
      statusCode: response.status
    };
  }

  async get<Tout>(
    method: string = '',
    defaultErrorHandling: RequestErrorHandler = RequestErrorHandler.Snackbar
  ): Promise<BaseConnectorResponse<Tout>> {
    const response = await axios.get<Tout>(`${this.url}${method}`, {
      defaultErrorHandling
    } as ExtendedAxiosRequestConfig);

    return {
      result: response.data,
      statusCode: response.status
    };
  }

  async put<Tout>(
    method: string = '',
    body?: any,
    defaultErrorHandling: RequestErrorHandler = RequestErrorHandler.Snackbar
  ): Promise<BaseConnectorResponse<Tout>> {
    const response = await axios.put<Tout>(`${this.url}${method}`, body, {
      defaultErrorHandling
    } as ExtendedAxiosRequestConfig);

    return {
      result: response.data,
      statusCode: response.status
    };
  }

  async patch<Tout>(
    id: string = '',
    patches: HttpPatch[],
    defaultErrorHandling: RequestErrorHandler = RequestErrorHandler.Snackbar
  ): Promise<BaseConnectorResponse<Tout>> {
    const response = await axios.patch<Tout>(`${this.url}/${id}`, patches, {
      defaultErrorHandling
    } as ExtendedAxiosRequestConfig);

    return {
      result: response.data,
      statusCode: response.status
    };
  }
}
